import { useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import apiCall from "../../api/api-call";
import authenticationService from "../../services/authentication.service";
import ApplicantTable from "./ApplicantTable";
import PostJobTable from "./PostJobTable";

function PostJobSection() {
  const [user, setUser] = useState(undefined);
  const [jobPost, setJobPost] = useState([]);
  const [applicants, setApplicants] = useState([]);
  const [verifyEmail, setVerifyEmail] = useState(null);
  const navigate = useNavigate();

  const signOut = async () => {
    authenticationService.signOut();
    navigate("/");
  };

  const handleVerifyEmail = async () => {
    apiCall
      .sendEmailVerification({ email: user.attributes.email })
      .then((response) => {
        toast.success("Confirmation email sent!");
      })
      .catch((error) => {
        console.log("error: ", error);

        if (
          error.response &&
          error.response.data &&
          error.response.data.duplicate
        ) {
          toast.error(
            "A previous email has already been sent. Please check inbox or spam folder."
          );
        } else {
          toast.error("Error sending email.");
        }
      });
  };

  useEffect(() => {
    authenticationService
      .getCurrentUser()
      .then((authUser) => setUser(authUser));

    authenticationService.getToken();
  }, []);

  useEffect(() => {
    if (!user || !user.username) {
      return;
    }

    apiCall
      .getJobList()
      .then((response) => {
        //console.log("getJobList response: ", response);
        setJobPost(response.data.response.Items);
        //console.log("setting job post");
      })
      .catch((error) => {
        console.log("error: ", error);
      });
  }, [user]);

  useEffect(() => {
    if (!user || !user.username) {
      return;
    }

    apiCall
      .getApplicantList()
      .then((response) => {
        //console.log("getApplicantList response: ", response);
        setApplicants(response.data.response.Items);
        //console.log("setting applicants");
      })
      .catch((error) => {
        console.log("error: ", error);
      });
  }, [user]);

  useEffect(() => {
    if (!user) {
      return;
    }

    apiCall
      .getEmailVerifyStatus()
      .then((response) => {
        //console.log("getEmailVerifyStatus response: ", response);
        setVerifyEmail(response.data.verified);
      })
      .catch((error) => {
        console.log("error: ", error);
      });
  }, [user]);

  return (
    <div className="section-post-job">
      {!user ? (
        <p>Loading ...</p>
      ) : (
        <>
          <div className="d-flex bd-highlight mb-3">
            <div className="p-2 bd-highlight">
              <h3 className="mb3">Hello {user.attributes.given_name}</h3>
            </div>
            <div className="ms-auto p-2 bd-highlight">
              <button className="btn btn-primary" onClick={signOut}>
                Sign Out
              </button>
            </div>
          </div>
          {verifyEmail === false && (
            <Alert variant="warning">
              <p>
                In order to get email notifications for your application job
                posts, you need to allow your email to subscribe. Click{" "}
                <Alert.Link href="#" onClick={() => handleVerifyEmail()}>
                  here to confirm
                </Alert.Link>
                .
              </p>
            </Alert>
          )}

          <div className="d-flex bd-highlight mb-3">
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin
              suscipit metus nisi, ut varius odio bibendum in. Nulla commodo
              laoreet tortor non hendrerit. Nam a ex vitae neque pharetra
              iaculis ut id leo. Nullam eu lorem placerat nisl porta feugiat.
              Phasellus mi dui, semper eu purus non, cursus vestibulum ipsum.
              Donec eu consequat velit. Morbi fermentum erat vel feugiat
              sagittis. Phasellus tempus quis massa quis molestie. Duis vitae
              sem vulputate, vehicula odio ullamcorper, placerat arcu.
            </p>
          </div>
          <PostJobTable jobPost={jobPost} />
          <ApplicantTable applicants={applicants} />
        </>
      )}
    </div>
  );
}

export default PostJobSection;
